import MobileTicketsList from './mobileTicketsList/MobileTicketsList';
import DesktopTicketsList from './desktopTicketsList/DesktopTicketsList';
import useWindowDimensions from '../../../../../../hooks/useWindowDimensions';

function PurchasedTicketsList({
  tickets,
  title,
  handleDownloadTicket,
  handleTicketRefund,
  handleAdditionalServices,
  expired = false,
}) {
  const { width } = useWindowDimensions();
  return (width >= 1024 ? (
    <DesktopTicketsList
      tickets={tickets}
      title={title}
      handleDownloadTicket={handleDownloadTicket}
      handleTicketRefund={handleTicketRefund}
      expired={expired}
      handleAdditionalServices={handleAdditionalServices}
    />
  ) : (
    <MobileTicketsList
      purchases={tickets}
      expired={expired}
      title={title}
      handleDownloadTicket={handleDownloadTicket}
      handleAdditionalServices={handleAdditionalServices}
      handleTicketRefund={handleTicketRefund}
    />
  ));
}

export default PurchasedTicketsList;
